import React, { useState } from "react"
import { Button, Card, CardBody, Collapse } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ProviderStockOutFilter from "./filter"

const ProviderStockOutComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onExportBtnClick,
  onAdvancedSearch,
  exportStatus,
}) => {
  const navigate = useNavigate()
  const [filterOpen, setFilterOpen] = useState(false)

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = filters => {
    onAdvancedSearch(filters)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
            CustomHeaderTitle Component Props:
            
            - loading: Boolean flag to display loading state
            - title: String to display as the header title
            - rowCount: Boolean to show/hide the row number selector
            - lgColumn: Number to control the width of columns based on layout needs
            - onChangeRowNumber: Callback function to handle row number selection change
            - orderingList: Boolean to show/hide ordering dropdown
            - onChangeOrdering: Callback function triggered when the ordering option is changed
            - searchBox: Boolean to show/hide search input box
            - onSearchHandler: Function called on key up in the search box
            - rightBtn: Boolean to show/hide right-side button (for example, a back button)
            - rightBtnTitle: String for setting the right button's label
            - rightBtnRoute: Route for the right button's navigation
            - exportBtn: Boolean to show/hide export button
            - onExportBtnClick: Callback for when the export button is clicked
            - exportBtnLoading: Boolean flag to show loading state during export functionality
            - advnacedSearchBtn: Boolean to show/hide advanced search button
            - advnacedSearchBtnTitle: String to display the advanced search button label
            - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
            - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
          */}
          <CustomHeaderTitle
            loading={loading}
            title={"Stock Out "}
            lgColumn={4}
            rowCount={false}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={false}
            onChangeOrdering={onChangeOrdering}
            searchBox={false}
            onSearchHandler={onSearch}
            rightBtn={false}
            exportBtn={true}
            onExportBtnClick={onExportBtnClick}
            exportBtnLoading={exportStatus?.loading}
            advnacedSearchBtn={false}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "expire_date", name: "Expire Date" },
              { value: "date", name: "Submission Date" },
            ]}
          />
          <Collapse isOpen={filterOpen}>
            {/* Provider Stock out Filter Component  */}
            <ProviderStockOutFilter
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>
          <p
            style={{
              textAlign: "center",
              fontSize: 15,
              fontWeight: 600,
              color: "red",
            }}
          >
            Note: Stock out quantity for 6 months
          </p>

          {/*
            GeneralTables Component Props:

            - data: Array containing the data to be displayed in the table
            - loading: Boolean indicating the loading state of the table
            - parentCheckbox: Boolean to determine if a parent checkbox is included in the table
            - headers: Array of strings representing the column headers for the table
            - pagination: Object containing pagination metadata and a callback function:
                - meta: Object for pagination details (e.g., page number, total items)
                - onPageClick: Callback function to handle page number changes
            - renderItem: Function to render each row/item in the table using the provided data
          */}
          <GeneralTables
            data={data}
            loading={loading}
            headers={[
              "SN",
              "UNFPA ITEM ID",
              "IP- ITEM DESCRIPTION",
              "AMC ( Last Year )",
              "Current Stock out Qty",
              "Current Balance",
              "Stock out Period ( Per Month )",
              "Estimated ( Stock Out Date )",
            ]}
            renderItem={(data, index) => (
              <tr key={index}>
                <th scope="row">{index + 1}</th>
                <td>{data?.unfpa_item}</td>
                <td>{data?.ip_item}</td>
                <td>{data?.prevTotal}</td>
                <td>{data?.stockOut}</td>
                <td>{data?.balance}</td>
                <td>{data?.priod_per_month}</td>
                <td>{data?.stockDate}</td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default ProviderStockOutComponent
